var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { ErrorHandler, } from '@angular/core';
import { ErrorTracking } from './error-tracking.service';
var CustomErrorHandler = /** @class */ (function (_super) {
    __extends(CustomErrorHandler, _super);
    function CustomErrorHandler(errorTracking, platformId, response) {
        var _this = _super.call(this) || this;
        _this.errorTracking = errorTracking;
        _this.platformId = platformId;
        _this.response = response;
        _this.isBrowser = isPlatformBrowser(_this.platformId);
        return _this;
    }
    CustomErrorHandler.prototype.handleError = function (error) {
        // When on the server, abort & return a 500
        if (isPlatformServer(this.platformId)) {
            this.response.status(500);
            this.response.locals.error = error.rejection ? error.rejection : error;
            return;
        }
        // When on the browser, report to Sentry
        this.errorTracking.captureException(error.originalError || error);
        // Angular's native error handler breaks WebDriverJS console read API.
        // FIXME: detect Protractor env better
        if (isPlatformBrowser(this.platformId) &&
            window.location.host === 'localhost:5000') {
            console.error(error);
        }
        else {
            _super.prototype.handleError.call(this, error);
        }
    };
    return CustomErrorHandler;
}(ErrorHandler));
export { CustomErrorHandler };
